var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{attrs:{"id":"privacyBox"}},[_c('el-col',[_c('div',{staticClass:"margin-top-3rem",attrs:{"id":"contentBox"}},[_c('VueMarkdown',{attrs:{"source":_vm.privacyText}})],1)]),_c('ReTryDialog',{attrs:{"dialogVisible":_vm.reTryVisible,"message":_vm.reLoginMsg}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }